<!--Main Menu-->
<div>
	<!--Course Selector-->
	<caass-course-selector (SectionSelected)="onSectionSelected($event)"> </caass-course-selector>

	<!--Class Attendance Menu-->
	<caass-class-attendance-menu [SectionScheduleDetailID]="SectionScheduleDetailID" [SelectDate]="SelectDate" [SchoolID]="SchoolID">
	</caass-class-attendance-menu>
</div>
